import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { imgUrl } from "../../lib/api";
import { waFor } from "../../lib/site";
import { WhatsAppIcon } from "./Icons";

export const DiscountBadge = ({ className = "", testId }) => {
  const { settings } = useSite();
  if (!settings.campaign_active || !settings.campaign_badge) return null;
  return <span className={`badge-gold ${className}`} data-testid={testId}>{settings.campaign_badge}</span>;
};

export const ServiceCard = ({ s }) => (
  <article data-testid={`service-card-${s.slug}`} className="card-lux group flex flex-col overflow-hidden hover:-translate-y-1">
    <Link to={`/hizmet/${s.slug}`} className="relative block aspect-[4/3] overflow-hidden" tabIndex={-1} aria-hidden="true">
      <img
        src={imgUrl(s.image)}
        alt={`lunessa-sivas-${s.slug}`}
        loading="lazy"
        decoding="async"
        width="600"
        height="450"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
      />
      <span className="absolute inset-0 bg-gradient-to-t from-emerald-950/35 via-transparent to-transparent" />
      <DiscountBadge className="absolute left-4 top-4" testId={`service-badge-${s.slug}`} />
    </Link>
    <div className="flex flex-1 flex-col p-6">
      <div className="mb-2 flex items-center justify-between gap-3">
        <h3 className="text-lg font-semibold text-emerald-950">
          <Link to={`/hizmet/${s.slug}`} className="transition-colors hover:text-emerald-700">{s.title}</Link>
        </h3>
        {s.duration && (
          <span className="flex shrink-0 items-center gap-1 text-xs text-ink/55">
            <Clock className="h-3.5 w-3.5 text-gold-deep" strokeWidth={1.8} /> {s.duration}
          </span>
        )}
      </div>
      <p className="mb-6 flex-1 text-sm leading-relaxed text-ink/65">{s.short_desc}</p>
      <div className="flex flex-wrap gap-2">
        <Link to={`/hizmet/${s.slug}`} className="btn-outline flex-1 !px-4 !py-2.5 text-[13px]" data-testid={`service-detail-btn-${s.slug}`}>
          Detayları İncele <ArrowRight className="h-3.5 w-3.5" />
        </Link>
        <a href={waFor(s.title)} target="_blank" rel="noopener noreferrer" className="btn-emerald flex-1 !px-4 !py-2.5 text-[13px]" data-testid={`service-randevu-btn-${s.slug}`}>
          <WhatsAppIcon className="h-4 w-4" /> Randevu Al
        </a>
      </div>
    </div>
  </article>
);

export const ServiceGrid = ({ services }) => (
  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-testid="services-grid">
    {services.map((s) => <ServiceCard key={s.id || s.slug} s={s} />)}
  </div>
);
